import { useCallback, useEffect, useState } from 'react';
import { getDocs } from 'firebase/firestore';
import { getAllDebtPayments } from '../../../services/debtService';
import { userCollection } from '../../lib/firebase';
import { uid } from './useAssetsUI';

/** Khoản trả nợ (subcollection) — tải lazy, không realtime; gọi reload() sau khi ghi. */
export const useDebtPayments = () => {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const reload = useCallback(async () => {
    const u = uid(); if (!u) return;
    setLoading(true);
    try { const r: any = await getAllDebtPayments(u); if (r?.success) setRows(r.data ?? []); } catch { /* giữ dữ liệu cũ */ }
    setLoading(false);
  }, []);
  useEffect(() => { reload(); }, [reload]);
  return { rows, loading, reload };
};

/** Lịch sử biến động số dư (collection `transactions`, ~400+ dòng) — chỉ tải khi mở tab Đối soát. */
export const useTxLogs = (enabled: boolean) => {
  const [rows, setRows] = useState<any[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const load = useCallback(async () => {
    const u = uid(); if (!u) return;
    setError(null);
    try { setRows((await getDocs(userCollection(u, 'transactions'))).docs.map(d => ({ id: d.id, ...d.data() }))); }
    catch (e) { setError((e as Error).message); }
  }, []);
  useEffect(() => { if (enabled && rows === null) load(); }, [enabled, rows, load]);
  return { rows, error, reload: load };
};
